/** PROTOTYPE hook: real project welding-services price from the engine (billed once).
 *  Debounced and cancellable, keyed off the request body. Idle when services are disabled. */
import { useEffect, useState } from 'react';
import { ProjectState } from './spreadSplitData';
import { fetchServicesPrice, buildServicesRequest, ServicesPriceResult } from './spreadPricingApi';

export type ServicesPriceState =
  | { status: 'idle' | 'loading' }
  | { status: 'done'; result: ServicesPriceResult }
  | { status: 'error'; error: string };

export function useServicesPrice(project: ProjectState): ServicesPriceState {
  const [state, setState] = useState<ServicesPriceState>({ status: 'idle' });
  const enabled = project.services.enabled;
  const bodyKey = enabled ? JSON.stringify(buildServicesRequest(project)) : 'disabled';

  useEffect(() => {
    if (!enabled) { setState({ status: 'idle' }); return; }
    let cancelled = false;
    setState({ status: 'loading' });
    const t = setTimeout(async () => {
      try {
        const result = await fetchServicesPrice(project);
        if (!cancelled) setState({ status: 'done', result });
      } catch (e) {
        if (!cancelled) setState({ status: 'error', error: e instanceof Error ? e.message : 'Request failed' });
      }
    }, 500);
    return () => { cancelled = true; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, bodyKey]);

  return state;
}
